/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImportCSVTypes {
    Customer = 10,
    NAVInvoice = 20,
    ProductPrice = 30,
    Product = 40,
}
